module.exports = __webpack_public_path__ + "img/thumbnails-13-speech-text-reader.2043a23a.png";